import React, { useEffect, useState } from 'react';
import styled, { keyframes, css } from 'styled-components';

const CheckBox = ({ id, initState, onChecked }) => {
  const iconNormal =
    process.env.PUBLIC_URL + '/images/common/icon-24-checkbox-active.svg';
  const iconChecked =
    process.env.PUBLIC_URL + '/images/common/icon-24-checkbox-selected.svg';

  const [checked, setChecked] = useState(initState);

  function toggle() {
    onChecked(!checked);
    setChecked(!checked);
  }

  useEffect(() => {
    setChecked(initState);
  });

  return (
    <>
      <div onClick={() => toggle()}>
        <img src={checked ? iconChecked : iconNormal} alt="" />
      </div>
    </>
  );
};

export default CheckBox;
